/* =========================================================================
   GBN pre-orders: switch the product page between "Add to cart" and
   "Pre-order" as the customer changes variant. Markup:
   snippets/gbn-preorder-product.liquid.
   ========================================================================= */
(function() {
  'use strict';

  function apply(box, variant) {
    var ids = box.getAttribute('data-variants') || '';
    var isPreorder = !!variant && variant.available && ids.indexOf(',' + variant.id + ',') > -1;
    var form = box.closest('form');
    var input = box.querySelector('[data-gbn-preorder-input]');

    box.hidden = !isPreorder;
    if (input) input.disabled = !isPreorder;
    if (form) form.classList.toggle('gbn-is-preorder', isPreorder);

    if (!isPreorder || !form) return;

    // Debut has already set the button for this variant; relabel it.
    var label = box.getAttribute('data-label');
    var button = form.querySelector('[data-add-to-cart]');
    var text = form.querySelector('[data-add-to-cart-text]');
    if (button) button.setAttribute('aria-label', label);
    if (text) text.textContent = label;
  }

  // Debut fires "variantChange" on the product section when options change;
  // it bubbles here after Debut's own handler has updated the button.
  document.addEventListener('variantChange', function(evt) {
    var container = evt.target;
    if (!container || !container.querySelector) return;
    var box = container.querySelector('[data-gbn-preorder]');
    if (box) apply(box, evt.detail && evt.detail.variant);
  });
})();
